

async function getGoogleMapsData(address) {
  const encodedAddress = encodeURIComponent(address);
  const mapsLink = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
  const streetViewUrl = `https://maps.googleapis.com/maps/api/streetview?size=600x300&location=${encodedAddress}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`;
  
  let latitude = null;
  let longitude = null;

  try {
    const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${encodedAddress}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`);
    const data = await response.json();
    if (data.status === 'OK' && data.results.length > 0) {
      const location = data.results[0].geometry.location;
      latitude = location.lat;
      longitude = location.lng;
    }
  } catch (error) {
    console.error('Error fetching geolocation:', error);
  }

  return {
    address,
    maps_link: mapsLink,
    street_view_image: streetViewUrl,
    latitude,
    longitude
  };
}

export default getGoogleMapsData;